import { useState } from 'react'
import { HiSquares2X2 } from 'react-icons/hi2'
import type { Resource } from './model'

export default function ResourceIcon({ resource }: { resource: Resource }) {
  const [failedSource, setFailedSource] = useState<string | null>(null)
  const showImage = resource.imageSrc && resource.imageSrc !== failedSource
  const Icon = resource.icon || HiSquares2X2
  return <span className={`hp-resource-icon hp-tone-${resource.kind.toLowerCase()} ${showImage ? 'hp-resource-logo' : ''}`}>
    {showImage ? <img src={resource.imageSrc} alt="" aria-hidden="true" loading="lazy" decoding="async"
      onError={() => setFailedSource(resource.imageSrc || null)} /> : <Icon aria-hidden="true" />}
  </span>
}
